module.exports = __webpack_public_path__ + "static/media/cart-thin.0c91880a.svg";